/**
 * AusMed logo bar — mobile: horizontal snap between slides (batched logos) + dot pagination (Figma 2107:34592).
 * Desktop: no-op (CSS hides dots; wrapped grid via display:contents on slides).
 */

function getSlides(scroller) {
  return scroller.querySelectorAll('[data-ausmed-logo-slide]');
}

function activeSlideIndex(scroller) {
  const slides = getSlides(scroller);
  const n = slides.length;
  if (n <= 1) return 0;
  const w = scroller.clientWidth;
  if (w < 1) return 0;
  const x = scroller.scrollLeft + w * 0.45;
  for (let i = n - 1; i >= 0; i -= 1) {
    if (slides[i].offsetLeft <= x) return i;
  }
  return 0;
}

function initLogoBarSlider(root) {
  const scroller = root.querySelector('[data-ausmed-logo-bar-scroller]');
  const dotsRoot = root.querySelector('[data-ausmed-logo-bar-dots]');
  if (!scroller || !dotsRoot) return;

  let dotButtons = [];
  const mq = window.matchMedia('(max-width: 749px)');

  function setDotStyles() {
    if (!mq.matches || dotButtons.length === 0) return;
    const activeIdx = activeSlideIndex(scroller);
    dotButtons.forEach((btn, i) => {
      const active = i === activeIdx;
      btn.classList.toggle('ausmed-c-pagination-dot--active', active);
      btn.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function scrollToSlide(index) {
    const slides = getSlides(scroller);
    const n = slides.length;
    if (n <= 1 || !slides[index]) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const left = slides[index].offsetLeft;
    scroller.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
  }

  function rebuild() {
    if (!mq.matches) {
      dotsRoot.setAttribute('hidden', '');
      dotsRoot.setAttribute('aria-hidden', 'true');
      dotsRoot.replaceChildren();
      dotButtons = [];
      return;
    }

    const slides = getSlides(scroller);
    const count = slides.length;
    dotsRoot.replaceChildren();
    dotButtons = [];

    if (count <= 1) {
      dotsRoot.setAttribute('hidden', '');
      dotsRoot.setAttribute('aria-hidden', 'true');
      return;
    }

    dotsRoot.removeAttribute('hidden');
    dotsRoot.setAttribute('aria-hidden', 'false');

    for (let i = 0; i < count; i += 1) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ausmed-c-pagination-dot';
      if (i === 0) btn.classList.add('ausmed-c-pagination-dot--active');
      btn.setAttribute('aria-label', `Go to partners slide ${i + 1} of ${count}`);
      btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      btn.addEventListener('click', () => scrollToSlide(i));
      dotsRoot.appendChild(btn);
      dotButtons.push(btn);
    }
    setDotStyles();
  }

  function onScroll() {
    if (!mq.matches || dotButtons.length === 0) return;
    setDotStyles();
  }

  scroller.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', rebuild, { passive: true });
  mq.addEventListener('change', rebuild);

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(rebuild);
    });
    ro.observe(scroller);
  }

  window.addEventListener('load', rebuild, { passive: true });

  scroller.querySelectorAll('img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', () => requestAnimationFrame(rebuild), { once: true });
  });

  rebuild();
  requestAnimationFrame(() => {
    requestAnimationFrame(rebuild);
  });
}

document.querySelectorAll('[data-ausmed-logo-bar-slider]').forEach((root) => {
  initLogoBarSlider(root);
});
